import BubbleTimer from '@/components/dataDisplay/BubbleTimer';
import ChatbotQuestion from '@/modules/core/data/types/CDE/ChatbotQuestion';
import { ChatbotContext } from '@/modules/core/data/types/ChatbotContext';
import size from 'lodash.size';
import React from 'react';

type Props = {
  question: ChatbotQuestion;
  activeQuestion: ChatbotQuestion;
  context: ChatbotContext;
  bubbleTimerDuration: number;
  children: React.ReactElement | ((props: Props) => React.ReactElement);
}

const shouldDisplayQuestion = (question: ChatbotQuestion, activeQuestion: ChatbotQuestion, context: ChatbotContext): boolean => {
  if (question === null) {
    return true;
  } else {
    // Bit too complex to my taste, but will do for now
    const isPreviousQuestionAnswered: boolean = question.ref === activeQuestion.ref ? true : typeof context[question.ref] !== 'undefined' || typeof context[activeQuestion.ref] !== 'undefined';
    const hasValidChoices = question.hideIfNoChoice ? !!size(question.choices) : true; // Do not display a question that doesn't have any choice, if the question should be hidden in such case

    return (question.order <= activeQuestion.order) && isPreviousQuestionAnswered && hasValidChoices;
  }
};

const Question: React.FunctionComponent<Props> = (props): JSX.Element => {
  const {
    question,
    activeQuestion,
    context,
    bubbleTimerDuration,
    children,
  } = props;
  const isVisible = shouldDisplayQuestion(question, activeQuestion, context);

  if (!isVisible) {
    return null;
  }

  const resolvedChildren: React.ReactElement = typeof children === 'function' ? children(props) : children as React.ReactElement;

  return (
    <BubbleTimer duration={bubbleTimerDuration}>
      {resolvedChildren}
    </BubbleTimer>
  );
};

export type QuestionProps = {} & Props;

export default Question;
